module.exports = __webpack_public_path__ + "static/media/LPC.7e43fbaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/LPC.png
// module id = 345
// module chunks = 0